__turbopack_context__.v({
  "list": "OY7Ahq_list",
  "title": "OY7Ahq_title",
  "trigger": "OY7Ahq_trigger",
  "wrapper": "OY7Ahq_wrapper",
});
